/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.validation.required\":[\"Minst ett val krävs.\"],\"checkbox-group.label.optional\":[\"Valfritt\"]}");
//# sourceMappingURL=messages.mjs.map